import { useTheme } from 'foundations-theming-specialty/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RemoveIcon = ({
  title,
  style,
  color
}) => {
  const theme = useTheme();
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: color || theme.color['icon-secondary-subtle'],
    style: style,
    children: [title ? /*#__PURE__*/_jsx("title", {
      children: title
    }) : null, /*#__PURE__*/_jsx("path", {
      d: "M2.71 26.79c.312.314.743.508 1.22.508s.908-.194 1.22-.507L16 15.941l10.86 10.85c.312.312.744.505 1.22.505.953 0 1.725-.772 1.725-1.725 0-.476-.193-.908-.505-1.22l-10.86-10.85 10.85-10.86c.279-.305.45-.713.45-1.16 0-.95-.77-1.72-1.72-1.72-.448 0-.856.171-1.162.452l.001-.001-10.86 10.85L5.139.212c-.316-.344-.767-.56-1.27-.56-.95 0-1.72.77-1.72 1.72 0 .502.215.954.558 1.268l.001.001 10.85 10.86-10.85 10.86c-.311.311-.503.741-.503 1.215s.192.904.503 1.215z"
    })]
  });
};
export default RemoveIcon;